import { F5 } from "@angular/cdk/keycodes";
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { Version } from "../webhook-edit.component";
import { DebugInterface, WebhookDebugServices } from "../../webhook-services/webhook-debug.services";
import { FlowData } from "../../webhook-interfaces/flowdata";
import { WebhookField } from "../../webhook-interfaces/configuration";
import { FormBuilder, FormGroup } from "@angular/forms";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";

export interface ToolboxEvent {
    action: string;
    data?: any;
}

@Component({
    selector: 'webhook-debug-toolbar',
    templateUrl: './webhook-debug-toolbar.component.html',
    styleUrl: './webhook-debug-toolbar.component.scss',
    standalone: false,
    host:{
        '(document:keydown)': 'onKeyDown($event)'
    }
})

export class WebhookDebugToolbarComponent implements OnInit {

    selectedCodeCompany:number;
    
    changeCompany(value, field:WebhookField){
        this.selectedCodeCompany = value;
        this.actionPerformed.next({action:'changeCompany', data:value});
    }

    stopFlow() {
        this.actionPerformed.next({action:'stopFlow'});
    }
    
    continueFlow() {
        this.stepping = false;
        this.actionPerformed.next({action:'continueFlow'});
    }
    
    startFlow() {
        this.actionPerformed.next({action:'startFlow'});
    }

    @Output() actionPerformed:EventEmitter<ToolboxEvent> = new EventEmitter<ToolboxEvent>();
    @Input()selectedVersion:Version;
    @Input()flowData:FlowData;
    debug:string = '';
    stepping = false;
    debugging:DebugInterface;
    disableStart = true;
    disableStepping = true;
    form:FormGroup;

    
    fieldCfgCompany:WebhookField = null;
        
        


    constructor(private debugService:WebhookDebugServices, private _cd:ChangeDetectorRef, private fb:FormBuilder,
        private uas:UserAuthenticationServices
    ){}
    
    ngOnInit(): void {
        this.form = this.fb.group({
            CODECOMPANY: [null]
        });

        this.fieldCfgCompany = {
            field: 'CODECOMPANY',
            label: 'codecompany',
            required: true,
            size: 'large',
            placeholder:'codecompany',
            noLabel:true,
            type: 'querySelect',
            condition: `SELECT MKTPCFGCOMPANY.CODECOMPANY as VALUE, MKTPCOMPANIES.NAME as LABEL FROM MKTPCFGCOMPANY 
                                INNER JOIN MKTPCOMPANIES ON MKTPCFGCOMPANY.CODECOMPANY=MKTPCOMPANIES.CODECOMPANY 
                                WHERE MKTPCFGCOMPANY.IDCONF=${this.flowData.idconf}
                                AND MKTPCFGCOMPANY.CODECOMPANY IN (${this.uas.getCompanies()})
                                 ORDER BY NAME`,
            showKey:true
            
        }

        this.debugService.debugging$.subscribe(sub=>{
                this.debugging  = sub;
                
                if (this.debugging == null || this.debugging.debugging == null || this.debugging.debugging == "STOPPED" ||  this.debugging.debugging == ""){
                    this.disableStart = false;
                }else{
                    this.disableStart = true;
                }

                if ( this.debugging != null && this.debugging.debugging == 'STEPPING'){
                    this.disableStepping = false;
                }else{
                    this.disableStepping = true;
                }
            
        
                this._cd.detectChanges();
        });
    }

    startDebug(){
         
        
    }

    
    onKeyDown(event: KeyboardEvent): void {
        if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
      return;
    }
        switch (event.keyCode) {
            case F5 : this.startDebug();
        }
    }


}